import { useState } from "react";
import { toast } from "sonner";
import { startCheckout } from "@/lib/api";
import { trackEvent } from "@/lib/analytics";

export default function useDirectCheckout() {
  const [loadingKey, setLoadingKey] = useState(null);

  const buy = async ({ key, variant, productName, price, category }) => {
    if (loadingKey) return;
    setLoadingKey(key);
    trackEvent("add_to_cart", { product_name: productName, product_category: category, product_price: price, currency: "USD" });
    trackEvent("begin_checkout", { product_name: productName, product_category: category, value: price, currency: "USD" });
    try {
      // Supports a marketing link like /?promo=PICKLE20 applying one of the 4
      // Complete-System-only codes to a direct homepage "Buy Now" — validated
      // server-side the same way as the cart drawer's Apply button.
      const discountCode = new URLSearchParams(window.location.search).get("promo") || undefined;
      await startCheckout({ variant, quantity: 1, discountCode });
    } catch (err) {
      trackEvent("stripe_checkout_error", { product_category: category });
      toast.error("Couldn't start checkout. Please try again.");
      setLoadingKey(null);
    }
  };

  return { loadingKey, buy };
}
